import initTemplate from './components/Template';
import initUiBase from './components/UiBase';
import initLastChanceModule from './components/UiBase/LastChanceModule';

import globalListeners from './globalListeners';

import initInBlogArea from './components/Homepage_v3/InBlogArea';

import initBoardPage from './components/BoardPage';
import trainerSwiper from './components/BoardPage/trainerSwiper';
import momentsSwiper from './components/BoardPage/moments-swiper';

$(function () {
  globalListeners();

  initTemplate();
  initUiBase();
  initLastChanceModule();

  initInBlogArea();

  initBoardPage();
  trainerSwiper();
  momentsSwiper();
});
